import PropTypes from 'prop-types';
import React from 'react';
import '../styles/EmbeddedChatWidget.scss';

class EmbeddedChatWidget extends React.PureComponent {
  render() {
    const { widget, classes } = this.props;
    const iframeSrc = `/widgets/chat_widget/${widget}`;

    return (
      <div className={`cp-embedded-chat-widget ${widget}-widget ${classes || ''}`}>
        <iframe src={iframeSrc} />
      </div>
    );
  }
}

EmbeddedChatWidget.propTypes = {
  widget: PropTypes.string.isRequired,
  classes: PropTypes.string
};

export default EmbeddedChatWidget;
